var _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _circle, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOfferIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.0122 26.4103C41.4712 26.0172 42.0166 25.7382 42.6039 25.5958C44.5585 25.1214 45.5358 23.4934 45.5358 21.8654C45.5358 20.2374 44.5585 18.6094 42.6039 18.135C42.0171 17.9923 41.4723 17.7131 41.0138 17.32C40.5552 16.927 40.1958 16.4313 39.9648 15.8731C39.7338 15.315 39.6377 14.7102 39.6843 14.1079C39.7309 13.5056 39.9189 12.9229 40.233 12.4069C42.3256 8.96829 38.3919 5.03524 34.9569 7.12871C34.441 7.44341 33.8581 7.63178 33.2556 7.67851C32.6532 7.72524 32.0482 7.629 31.49 7.39762C30.9317 7.16625 30.436 6.80627 30.0431 6.347C29.6502 5.88772 29.3712 5.34213 29.2289 4.75462C28.2806 0.843837 22.7195 0.843837 21.7712 4.75462C21.1568 7.28238 18.2716 8.48056 16.0454 7.12648C12.6082 5.03301 8.67674 8.96829 10.7694 12.4047C11.0839 12.9208 11.2722 13.504 11.3189 14.1067C11.3656 14.7094 11.2694 15.3146 11.0382 15.8731C10.8069 16.4316 10.4471 16.9275 9.98797 17.3206C9.52888 17.7136 8.98351 17.9927 8.39624 18.135C6.44165 18.6094 5.46435 20.2374 5.46435 21.8654C5.46435 23.4934 6.44165 25.1214 8.39624 25.5958C8.98298 25.7386 9.52778 26.0178 9.98635 26.4108",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.532 27.0027V31.7839L10.8375 36.975",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9062 27.0027V31.7839L19.125 35.7683V42.9402",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 27.0024V31.7837L41.4375 36.9747",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6875 27.0024V31.7837L33.4688 35.7681V42.9399",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.2875,
    cy: 40.208,
    rx: 3.1875,
    ry: 3.1875,
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.125,
    cy: 46.1274,
    rx: 3.1875,
    ry: 3.1875,
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.4688,
    cy: 46.1274,
    r: 3.1875,
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9011 40.1623C46.9011 41.9228 45.474 43.3498 43.7136 43.3498C41.9532 43.3498 40.5261 41.9228 40.5261 40.1623C40.5261 38.4019 41.9532 36.9749 43.7136 36.9749C45.474 36.9749 46.9011 38.4019 46.9011 40.1623Z",
    stroke: "#1A279A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0248 14.5713C14.0248 14.2193 14.3102 13.9338 14.6623 13.9338H19.6084C19.9605 13.9338 20.2459 14.2193 20.2459 14.5713C20.2459 14.9234 19.9605 15.2088 19.6084 15.2088H15.2998V17.6969H18.6192C18.9713 17.6969 19.2567 17.9823 19.2567 18.3344C19.2567 18.6864 18.9713 18.9719 18.6192 18.9719H15.2998V21.9026H19.6084C19.9605 21.9026 20.2459 22.188 20.2459 22.5401C20.2459 22.8922 19.9605 23.1776 19.6084 23.1776H14.6623C14.3102 23.1776 14.0248 22.8922 14.0248 22.5401V14.5713Z",
    fill: "#1A279A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1579 14.5713C22.1579 14.2193 22.4433 13.9338 22.7954 13.9338H25.4334L25.4357 13.9338L25.4389 13.9339L25.4484 13.9339L25.4784 13.9345C25.5032 13.9351 25.5374 13.9362 25.5798 13.9384C25.6642 13.9428 25.782 13.9514 25.9222 13.9684C26.1994 14.002 26.5802 14.0702 26.9702 14.212C27.3569 14.3526 27.7888 14.5787 28.129 14.9499C28.482 15.335 28.7088 15.8476 28.7088 16.4897C28.7088 17.1319 28.482 17.6445 28.129 18.0296C27.7888 18.4007 27.3569 18.6268 26.9702 18.7675C26.8124 18.8248 26.6561 18.8702 26.5075 18.906L28.6086 22.197C28.7981 22.4938 28.7111 22.888 28.4143 23.0774C28.1176 23.2669 27.7234 23.1799 27.534 22.8831L25.084 19.0456H23.4329V22.5401C23.4329 22.8922 23.1475 23.1776 22.7954 23.1776C22.4433 23.1776 22.1579 22.8922 22.1579 22.5401V14.5713ZM23.4329 17.7706H25.4319L25.4334 17.7706L25.4475 17.7704C25.4614 17.77 25.4838 17.7693 25.5136 17.7678C25.5734 17.7646 25.6617 17.7583 25.7688 17.7453C25.9863 17.7189 26.2649 17.6672 26.5345 17.5692C26.8072 17.47 27.0348 17.3364 27.1892 17.168C27.3308 17.0136 27.4338 16.8068 27.4338 16.4897C27.4338 16.1727 27.3308 15.9659 27.1892 15.8114C27.0348 15.643 26.8072 15.5094 26.5345 15.4103C26.2649 15.3123 25.9863 15.2605 25.7688 15.2342C25.6617 15.2212 25.5734 15.2148 25.5136 15.2117C25.4838 15.2102 25.4614 15.2095 25.4475 15.2091L23.4329 15.2088M23.4329 15.2088V17.7706V15.2088Z",
    fill: "#1A279A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6222 14.5713C30.6222 14.2193 30.9077 13.9338 31.2597 13.9338H34.722L34.7235 13.9338L34.7252 13.9338L34.7291 13.9339L34.7389 13.934L34.7666 13.9348C34.7884 13.9356 34.8171 13.9372 34.8516 13.94C34.9205 13.9456 35.0141 13.9564 35.1243 13.9773C35.3422 14.0187 35.6403 14.1024 35.9443 14.2756C36.5942 14.6458 37.1731 15.3723 37.1731 16.6373C37.1731 17.1947 37.0283 17.6549 36.7787 18.0205C36.5323 18.3814 36.2096 18.6127 35.9085 18.7597C35.6095 18.9056 35.3185 18.9754 35.1078 19.0097C35.0009 19.0271 34.9104 19.036 34.8443 19.0406C34.8111 19.043 34.7838 19.0442 34.7631 19.0449L34.7373 19.0455L34.7283 19.0456L34.7248 19.0456L34.7233 19.0456L34.722 19.0456H31.8972V22.5401C31.8972 22.8922 31.6118 23.1776 31.2597 23.1776C30.9077 23.1776 30.6222 22.8922 30.6222 22.5401V14.5713ZM31.8972 17.7706H34.7184L34.7216 17.7705C34.7276 17.7704 34.7392 17.7699 34.7556 17.7687C34.7886 17.7664 34.8399 17.7615 34.903 17.7513C35.0323 17.7302 35.1947 17.6893 35.3491 17.6139C35.5014 17.5396 35.6321 17.4388 35.7257 17.3016C35.8162 17.1692 35.8981 16.9653 35.8981 16.6373C35.8981 15.8363 35.5702 15.5298 35.3133 15.3835C35.164 15.2985 35.0086 15.2531 34.8865 15.2299C34.8267 15.2186 34.7785 15.2132 34.7482 15.2108C34.7332 15.2095 31.902 15.209 31.8972 15.2088M31.8972 17.7706V15.2088V17.7706Z",
    fill: "#1A279A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferIcon1);
export default __webpack_public_path__ + "static/media/offer-icon-1.85fe461c34b8a5660b6967735fb370ac.svg";
export { ForwardRef as ReactComponent };